import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-432647661__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Schliessenbutton", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-432647661__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M96 176c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80M51 56.64l5.66-5.66 39.35 39.35 39.6-39.6 5.66 5.66-39.6 39.6L141 135.32l-5.66 5.66-39.33-39.33-39.59 39.59-5.66-5.66 39.59-39.59z",
      style: {"fill":"none"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M96 184c48.52 0 88-39.48 88-88S144.52 8 96 8 8 47.48 8 96s39.48 88 88 88m0-168c44.11 0 80 35.89 80 80s-35.89 80-80 80-80-35.89-80-80 35.89-80 80-80",
      class: "i-432647661__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "m56.42 141.24 39.59-39.59 39.33 39.33 5.66-5.66-39.33-39.33 39.6-39.59-5.66-5.66-39.6 39.6-39.35-39.35L51 56.64l39.36 39.35-39.6 39.6z",
      class: "i-432647661__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "close"}) } }